// front-end/src/components/news-loader/news-article-loader.js

import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {applyContentToElement, loadContentForElement} from '../content-editor-src';

export class NewsArticleLoader {
    constructor() {
        console.log('[NewsArticleLoader] Инициализация начата');
        this.container = null;
        this.init();
    }

    init() {
        console.log('[NewsArticleLoader] init() - начало');

        // Инициализируем только на странице News.html
        if (window.location.pathname.match(/\/News(\.html)?$|\/news\/|\/case\//)) {
            console.log('[NewsArticleLoader] Страница News.html - ищем контейнер');

            // Ждем полную загрузку DOM
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    this.findAndLoadNews();
                });
            } else {
                this.findAndLoadNews();
            }
        } else {
            console.log('[NewsArticleLoader] Не страница новости, пропускаем инициализацию');
        }
    }

    findAndLoadNews() {
        // Ищем контейнер по data-section
        this.container = document.querySelector('[data-section="news-section-1"]');
        console.log('[NewsArticleLoader] Контейнер найден:', !!this.container);

        if (this.container) {
            // Проверяем что это именно секция релевантных новостей
            const parentSection = this.container.closest('.news-relevant-feed-content-main');
            if (parentSection) {
                console.log('[NewsArticleLoader] Найдена секция релевантных новостей, загружаем');
                this.loadRelevantNews();
            } else {
                console.log('[NewsArticleLoader] Это не секция релевантных новостей, пропускаем');
            }
        } else {
            console.warn('[NewsArticleLoader] Контейнер news-section-1 не найден на странице новости');
        }
    }

    async loadRelevantNews() {
        console.log('[NewsArticleLoader] loadRelevantNews() - начало');

        try {
            // Очищаем контейнер от любого существующего контента
            this.container.innerHTML = '';

            // Получаем текущий slug из URL чтобы исключить текущую новость
            const pathMatch = window.location.pathname.match(/\/(?:news|case)\/([^/]+)/);
            const currentSlug = pathMatch ? pathMatch[1] : new URLSearchParams(window.location.search).get('slug');
            console.log('[NewsArticleLoader] Текущая новость:', currentSlug);

            // Загружаем топ 3 опубликованные новости, исключая текущую
            let apiUrl = `${config.api.paths.newsPublishedTop}?limit=3`;
            if (currentSlug) {
                apiUrl += `&exclude_slug=${encodeURIComponent(currentSlug)}`;
            }
            console.log('[NewsArticleLoader] API URL:', apiUrl);

            const response = await apiGet(apiUrl, {auth: false});

            let newsItems = Array.isArray(response) ? response : (response?.items || []);
            console.log('[NewsArticleLoader] Получено новостей:', newsItems.length);

            // Фильтруем кейсы (они уже должны быть отфильтрованы на бэкенде, но для надежности)
            newsItems = newsItems.filter(news => {
                const isCase = news.slug && news.slug.startsWith('case-');
                if (isCase) {
                    console.log(`[NewsArticleLoader] Фильтруем кейс: ${news.slug}`);
                }
                return !isCase;
            });

            console.log('[NewsArticleLoader] После фильтрации:', newsItems.length);

            if (newsItems.length > 0) {
                await this.renderRelevantNews(newsItems);
            } else {
                this.renderEmptyState();
            }

        } catch (error) {
            console.error('[NewsArticleLoader] Ошибка при загрузке релевантных новостей:', error);
            this.renderErrorState();
        }
    }

    async renderRelevantNews(newsItems) {
        console.log('[NewsArticleLoader] renderRelevantNews() - рендерим', newsItems.length, 'новостей');

        for (let i = 0; i < newsItems.length; i++) {
            const news = newsItems[i];
            console.log(`[NewsArticleLoader] Обрабатываем новость ${i + 1}:`, news.slug);

            try {
                const newsElement = this.createNewsElement(news);
                this.container.appendChild(newsElement);

                // Загружаем контент для элемента
                await this.loadNewsContent(newsElement, news);

                console.log(`[NewsArticleLoader] Новость ${news.slug} добавлена`);
            } catch (error) {
                console.error(`[NewsArticleLoader] Ошибка при обработке новости ${news.slug}:`, error);
            }
        }
    }

    createNewsElement(news) {
        const newsItem = document.createElement('div');
        newsItem.className = 'news-feed-item';
        const newsHref = news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`;
        newsItem.style.cursor = 'pointer';
        newsItem.addEventListener('click', (e) => {
            if (!e.target.closest('a')) window.location.href = newsHref;
        });

        // НЕ добавляем data-block атрибуты чтобы блочная система не пыталась управлять
        newsItem.innerHTML = `
            <div class="news-feed-content">
                <div class="news-feed-upper">
                    <img class="news-feed-image" src="" alt="News Image" 
                         data-content="${news.slug}-image" data-type="image" data-global="true">
                    <a href="${news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`}" class="news-link active">
                        <img src="/images/news-button.svg" alt="news-button" class="news-button default">
                        <img src="/images/news-button-hover.svg" alt="news-button-hover" class="news-button hover">
                    </a>
                </div>
                <div class="news-feed-info">
                    <h3 class="news-feed-title" data-content="${news.slug}-title" data-global="true"></h3>
                    <p class="news-feed-description" data-content="${news.slug}-description" 
                       data-type="textarea" data-global="true"></p>
                </div>
            </div>
        `;

        return newsItem;
    }

    async loadNewsContent(newsElement, news) {
        const contentElements = newsElement.querySelectorAll('[data-content]');

        for (const element of contentElements) {
            const tagId = element.getAttribute('data-content');
            const isGlobal = element.getAttribute('data-global') === 'true';

            try {
                const data = await loadContentForElement(element, '', tagId, isGlobal);
                if (data) {
                    applyContentToElement(element, data);
                } else {
                    this.setDefaultContent(element, news, tagId);
                }
            } catch (error) {
                console.warn(`[NewsArticleLoader] Ошибка загрузки контента для ${tagId}:`, error);
                this.setDefaultContent(element, news, tagId);
            }
        }
    }

    setDefaultContent(element, news, tagId) {
        if (tagId.endsWith('-title')) {
            element.textContent = news.title || '';
        } else if (tagId.endsWith('-description')) {
            element.textContent = news.preview_text || '';
        }
    }

    renderEmptyState() {
        this.container.innerHTML = `
            <div class="news-empty-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <p style="color: #666;">Немає інших новин</p>
            </div>
        `;
    }

    renderErrorState() {
        this.container.innerHTML = `
            <div class="news-error-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <p style="color: #666;">Не вдалося завантажити новини</p>
            </div>
        `;
    }
}

// Создаем и экспортируем экземпляр
export const newsArticleLoader = new NewsArticleLoader();